import { Tabs as BaseTabs } from "@base-ui/react/tabs"

import Link from "#Components/shared/link"
import cn from "#Utils/cn"

const Tabs = ({ tabs = [], activeTab, className = "", children, onValueChange }) => {
  // Fall back to first available tab if activeTab doesn't exist in tabs
  const validActiveTab = tabs.find((tab) => tab.value === activeTab) ? activeTab : tabs[0]?.value

  return (
    <BaseTabs.Root value={validActiveTab} onValueChange={onValueChange}>
      <div className="relative">
        <BaseTabs.List className={cn("c-tabs bg-surface-default", className)}>
          {tabs.map((tab) => (
            <BaseTabs.Tab
              key={tab.value}
              value={tab.value}
              className={cn("c-tabs__link cursor-pointer", {
                "c-tabs__link--active": tab.value === validActiveTab,
              })}
              data-text={typeof tab.label === "string" ? tab.label : undefined}
              data-state={tab.value === validActiveTab ? "active" : "inactive"}
              onClick={tab.onClick}
              nativeButton={!tab.href && !tab.to}
              render={
                tab.href || tab.to
                  ? (tabProps) => (
                      <Link {...tabProps} href={tab.href} to={tab.to} search={tab.search}>
                        {tab.label}
                      </Link>
                    )
                  : undefined
              }
            >
              {tab.label}
            </BaseTabs.Tab>
          ))}
          <BaseTabs.Indicator
            className="absolute bottom-0 h-0.5 bg-blue-500 transition-all duration-300 ease-in-out"
            style={{
              width: "var(--active-tab-width)",
              left: "var(--active-tab-left)",
            }}
          />
        </BaseTabs.List>
      </div>
      {children}
    </BaseTabs.Root>
  )
}

const TabPanel = ({ value, className = "", children, keepMounted = false }) => {
  return (
    <BaseTabs.Panel value={value} className={cn("mt-2", className)} keepMounted={keepMounted}>
      {children}
    </BaseTabs.Panel>
  )
}

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      href: PropTypes.string,
      to: PropTypes.string,
      search: PropTypes.object,
      onClick: PropTypes.func,
    }),
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  onValueChange: PropTypes.func,
}

TabPanel.propTypes = {
  value: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  keepMounted: PropTypes.bool,
}

Tabs.Panel = TabPanel

export default Tabs
